import { Controller } from "@hotwired/stimulus"

// Auto-closes the sidebar when a navigation link is clicked (mobile only)
export default class extends Controller {
  connect() {
    this.handleClick = this.handleClick.bind(this)
    this.element.addEventListener("click", this.handleClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick(event) {
    const link = event.target.closest('a')
    if (!link) return

    const href = link.getAttribute("href")
    if (!href || href === "#") return

    if (typeof Alpine === 'undefined') return

    const body = document.body
    const alpineData = Alpine.$data(body)
    if (!alpineData) return

    // Close sidebar on mobile/tablet (below lg breakpoint)
    if (window.matchMedia("(max-width: 1023px)").matches) {
      if ('sidebarToggle' in alpineData) {
        alpineData.sidebarToggle = false
      }
    }
  }
}
